import script from "./FileListItemIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileListItemIcon.vue?vue&type=script&lang=ts&setup=true"

import "./FileListItemIcon.vue?vue&type=style&index=0&id=7606584a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7606584a"]])

export default __exports__